import { Handle } from '@xyflow/react';
import { Box, Text } from '@mantine/core';
import { memo } from 'react';

import { isUnconfiguredConditionNode } from '../../helpers/flowNodes';
import FlowStepIcon from './FlowStepIcon';

const ConditionalNode = memo(({ data, onNodeSelect, isConnectable }) => {
  const details = [];
  const isUnconfiguredCondition = isUnconfiguredConditionNode({ data });

  for (const config of data.custom.config) {
    let detail;
    const value = data.custom.values[config.field];
    if (!value && config.type !== 'sectionStart') {
      continue;
    }
    detail = (data.custom.values[config.field] || [])
      .map((rule) => {
        return rule.inverseSelection ? `Not ${rule.name}` : rule.name;
      })
      .join(', ');

    if (detail) {
      if (config.overview && config.overview.inline) {
        details.push(
          <Text component="span" size="xs" ml="xs" key={data.custom.config.indexOf(config)}>
            {detail}
          </Text>
        );
      } else {
        details.push(
          <Text size="xs" key={data.custom.config.indexOf(config)}>
            {detail}
          </Text>
        );
      }
    }
  }

  if (isUnconfiguredCondition) {
    details.push(
      <Text size="xs" c="red" key="unconfigured-condition">
        Configure rules to save
      </Text>
    );
  }

  return (
    <>
      <Handle
        type="target"
        position="top"
        isConnectable={isConnectable}
        style={{ top: '-5px', width: '10px', height: '10px' }}
      />
      <Box ta="center" onClick={onNodeSelect} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4 }}>
        <FlowStepIcon icon={data.custom.key} />
        <Text size="sm" component="span">{data.label}</Text>
      </Box>
      <Text size="xs" c="dimmed">{details}</Text>
      <Handle
        type="source"
        position="bottom"
        id="conditionMatched"
        style={{ left: '25px', top: 'auto', background: 'var(--mantine-color-green-6)', bottom: '-5px', width: '10px', height: '10px' }}
        isConnectable={isConnectable}
      />
      <Handle
        type="source"
        position="bottom"
        id="conditionNotMatched"
        style={{ left: 'auto', right: '25px', background: 'var(--mantine-color-red-6)', bottom: '-5px', width: '10px', height: '10px' }}
        isConnectable={isConnectable}
      />
    </>
  );
});

export default ConditionalNode;
